import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Dash/Plus system`}</h1>
    <p>{`I first stumbled across `}<a parentName="p" {...{
        "href": "https://patrickrhone.com/dashplus/"
      }}>{`Patrick Rhone’s Dash/Plus System`}</a>{` in 2017, but I thought of it again recently. It’s great for paper checklists. Maybe you’ll find it useful or remarkable.`}</p>
    <p><img parentName="p" {...{
        "src": "https://patrickrhone.com/images/notemetadata.JPG",
        "alt": "Note metadata representation scan"
      }}></img></p>
    <h2>{`Related tools`}</h2>
    <ul>
      <li parentName="ul">{`If you’re looking for Dash/Plus but for digital checklists, you might like `}<a parentName="li" {...{
          "href": "https://mattgemmell.com/taskpaper-3/"
        }}>{`Taskpaper`}</a></li>
      <li parentName="ul">{`If you’re looking for that but for desktop notes, `}<a parentName="li" {...{
          "href": "https://brettterpstra.com/projects/nvalt/"
        }}>{`nvALT`}</a>{` (& the upcoming `}<a parentName="li" {...{
          "href": "https://brettterpstra.com/2019/04/10/codename-nvultra/"
        }}>{`nvUltra`}</a>{`) might be up your alley`}</li>
      <li parentName="ul">{`On iOS, the closest tool to nvALT is absolutely `}<a parentName="li" {...{
          "href": "https://getdrafts.com"
        }}>{`Drafts`}</a>{`, which is my `}<a parentName="li" {...{
          "href": "https://www.macstories.net/reviews/drafts-5-the-macstories-review/"
        }}>{`daily text editor`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      